/* tslint:disable */

declare var Object: any;
export interface CostsOfLivingInterface {
  "childCare": any;
  "food": any;
  "healthCare": any;
  "transportation": any;
  "utilities": any;
  "id"?: any;
}

export class CostsOfLiving implements CostsOfLivingInterface {
  "childCare": any;
  "food": any;
  "healthCare": any;
  "transportation": any;
  "utilities": any;
  "id": any;
  constructor(data?: CostsOfLivingInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `CostsOfLiving`.
   */
  public static getModelName() {
    return "CostsOfLiving";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of CostsOfLiving for dynamic purposes.
  **/
  public static factory(data: CostsOfLivingInterface): CostsOfLiving{
    return new CostsOfLiving(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'CostsOfLiving',
      plural: 'CostsOfLiving',
      properties: {
        "childCare": {
          name: 'childCare',
          type: 'any'
        },
        "food": {
          name: 'food',
          type: 'any'
        },
        "healthCare": {
          name: 'healthCare',
          type: 'any'
        },
        "transportation": {
          name: 'transportation',
          type: 'any'
        },
        "utilities": {
          name: 'utilities',
          type: 'any'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/CostsOfLiving.ts